const DesignSpecification = { 
    "design_specification": "AASHTO1993",
    "design_life": 10,
    "number_of_iterations": 100,
    "analysis_period": 10,
 }

export default DesignSpecification;